import { USER_ROLES } from './index';
import { PORTAL_ACCENT } from '../styles/portalTheme';

/** Backend `data.type` values for portal Aria handoff notifications. */
export const ARIA_NOTIFICATION_TYPE = {
  ARIA_HUMAN_HANDOFF_REQUESTED: 'aria_human_handoff_requested',
};

export const ARIA_ESCALATION_TARGET_TYPE = 'aria_escalation';

export const ARIA_HANDSOFF_PATH = '/aria-handsoff';
export const PARTNER_ARIA_HANDSOFF_PATH = '/partner-aria-handsoff';

export const ARIA_NOTIFICATION_CATALOG = {
  [ARIA_NOTIFICATION_TYPE.ARIA_HUMAN_HANDOFF_REQUESTED]: {
    recipientRole: USER_ROLES.ADMIN,
    recipientRoles: [USER_ROLES.ADMIN, USER_ROLES.PARTNER],
    actorRole: null,
    label: 'Aria handoff requested',
    accentColor: PORTAL_ACCENT,
    defaultMessage: 'A member requested human support from Aria',
  },
};

const normalizeTypeKey = (type) =>
  String(type || '')
    .trim()
    .toLowerCase();

export const getAriaNotificationMeta = (type) => {
  const key = normalizeTypeKey(type);
  return ARIA_NOTIFICATION_CATALOG[key] ?? null;
};

export const isAriaNotificationForRole = (type, userRole) => {
  const key = normalizeTypeKey(type);
  const meta = getAriaNotificationMeta(key);
  if (meta) {
    const roles = meta.recipientRoles ?? [meta.recipientRole];
    return roles.includes(userRole);
  }
  if (key === ARIA_ESCALATION_TARGET_TYPE) {
    return userRole === USER_ROLES.ADMIN || userRole === USER_ROLES.PARTNER;
  }
  return false;
};

export const pickAriaEscalationId = (source = {}) => {
  const nested = source.data ?? {};
  const targetType = String(source.targetType ?? nested.targetType ?? '')
    .trim()
    .toLowerCase();
  const targetId = source.targetId ?? nested.targetId ?? null;
  const escalationId =
    source.escalationId ??
    nested.escalationId ??
    source.escalation_id ??
    nested.escalation_id ??
    null;

  if (escalationId && String(escalationId).trim()) {
    return String(escalationId).trim();
  }

  if (targetId && String(targetId).trim()) {
    if (
      !targetType ||
      targetType === ARIA_ESCALATION_TARGET_TYPE ||
      targetType === ARIA_NOTIFICATION_TYPE.ARIA_HUMAN_HANDOFF_REQUESTED
    ) {
      return String(targetId).trim();
    }
  }

  return null;
};

/**
 * Deep link for push click / inbox row.
 * @param {object} params
 * @param {string} [params.type]
 * @param {string} params.viewerRole
 */
export const resolveAriaNotificationPath = ({ viewerRole }) => {
  if (viewerRole === USER_ROLES.PARTNER) {
    return PARTNER_ARIA_HANDSOFF_PATH;
  }

  return ARIA_HANDSOFF_PATH;
};
